import { Zap } from "lucide-react";

const COLS = [
  { title: "Product", links: ["Features", "How It Works", "Pricing", "iOS & Android"] },
  { title: "Science", links: ["Session Engine", "Interval Methodology", "Research Library", "Coaching Board"] },
  { title: "Company", links: ["About", "Coaches", "Careers", "Press Kit"] },
  { title: "Legal", links: ["Privacy", "Terms", "Medical Disclaimer"] },
];

export const Footer = () => (
  <footer data-testid="footer" className="relative bg-[#0A0A0A] border-t border-white/10 overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <div className="flex items-center gap-2">
            <span className="grid place-items-center h-8 w-8 bg-volt text-white">
              <Zap className="h-4 w-4" strokeWidth={3} />
            </span>
            <span className="font-display font-black text-2xl uppercase">Fit<span className="text-volt">/</span>50</span>
          </div>
          <p className="mt-5 text-sm text-neutral-500 leading-relaxed max-w-xs">
            Coach-grade workouts built around your minutes — 10, 20, 30, 40 or 50 at a time.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 border border-white/10 bg-carbon px-3 py-2 font-mono text-[10px] tracking-widest uppercase text-neutral-400">
            <span className="h-1.5 w-1.5 rounded-full bg-volt animate-pulse-dot" />
            All systems operational • v3.4.0
          </div>
        </div>

        {COLS.map((c) => (
          <div key={c.title} className="md:col-span-2">
            <h4 className="font-mono text-xs tracking-[0.25em] uppercase text-volt">{c.title}</h4>
            <ul className="mt-5 space-y-3">
              {c.links.map((l) => (
                <li key={l}>
                  <a
                    data-testid={`footer-link-${l.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    href={l === "Privacy" ? "/privacy" : l === "Terms" ? "/terms" : "#top"}
                    onClick={l === "Privacy" || l === "Terms" ? undefined : (e) => e.preventDefault()}
                    className="text-sm text-neutral-500 hover:text-volt transition-colors duration-200"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>

    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div
        aria-hidden
        className="font-display font-black uppercase leading-[0.75] text-[22vw] md:text-[18vw] text-white/[0.04] select-none text-center -mb-6 md:-mb-10"
      >
        Fit50
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-mono text-[10px] tracking-widest uppercase text-neutral-600">
          © 2026 Fit50 Performance Inc. All rights reserved.
        </p>
        <p className="font-mono text-[10px] tracking-widest uppercase text-neutral-600 text-center">
          Not medical advice. Consult your physician before beginning any exercise program.
        </p>
      </div>
    </div>
  </footer>
);
